AoPS.Utils.initKeyChain(AoPS, "Alcumus");

AoPS.refreshOnBackButtonLoadWithOldData("alcumus");

AoPS.Alcumus = (function (Alcumus) {
	// Dependencies
	var Page = AoPS.Page;
	var Modal = AoPS.Ui.Modal;
	var Feed = AoPS.Feed;
	var bootstrap_data = AoPS.bootstrap_data || {};

	var AlcUrl = AoPS.Alcumus.Url;
	var AlcMasterModel = AoPS.Alcumus.Models.Master;
	var AlcVBase = AoPS.Alcumus.Views.Base;
	var AlcVProblem = AoPS.Alcumus.Views.Problem;
	var AlcVReport = AoPS.Alcumus.Views.Report;
	var AlcVProfile = AoPS.Alcumus.Views.Profile;
	var AlcVMisc = AoPS.Alcumus.Views.Misc;

	// Optional and can be loaded before or after this file
	// AoPS.Alcumus.Views.Admin

	// Set to true for pretty URLs, false for hash-based URLs. All the needed
	// changes to make either work are propagated by setting this variable.
	var USE_PUSH_STATE = true;

	var setupAlcPageMinHeightHack = _.once(function () {
		// Amount of pixels from vertical margin and padding of #main-column.
		var MAIN_COLUMN_SPACING = 25;
		var last_height = null;
		setInterval(function () {
			var curr_height = parseInt($("#main-content").css("min-height"));
			if (last_height !== curr_height) {
				last_height = curr_height;
				var alc_page_height = curr_height - MAIN_COLUMN_SPACING;
				$("#alc-page").css("min-height", alc_page_height + "px");
			}
		}, 200);
	});

	Alcumus.Router = Backbone.Router.extend({
		// We don't use Backbone's routes hash because Javascript objects aren't
		// ordered and Backbone is stupid for treating them as though they are.
		// Instead, we use an array of objects. An extra setup step in the
		// initialize method is required as a result.
		// url is the usual route URL pattern, f is the route function to call.
		route_data: [
			{
				// The 404 route must be first in this array so that it is matched last.
				url: "*notfound",
				f: "route404",
			},
			{
				url: AlcUrl.getUrlPattern("index", true),
				f: "routeIndex",
			},
			{
				url: AlcUrl.getUrlPattern("problem", true),
				f: "routeProblem",
			},
			{
				url: AlcUrl.getUrlPattern("report_redirect", true),
				f: "routeReportRedirect",
			},
			{
				url: AlcUrl.getUrlPattern("report", true),
				f: "routeReport",
			},
			{
				url: AlcUrl.getUrlPattern("report_subject", true),
				f: "routeReportSubject",
			},
			{
				url: AlcUrl.getUrlPattern("report_subject_topic", true),
				f: "routeReportSubjectTopic",
			},
			{
				url: AlcUrl.getUrlPattern("report_class", true),
				f: "routeReportClass",
			},
			{
				url: AlcUrl.getUrlPattern("report_class_topic", true),
				f: "routeReportClassTopic",
			},
			{
				url: AlcUrl.getUrlPattern("report_trial", true),
				f: "routeReportTrial",
			},
			{
				url: AlcUrl.getUrlPattern("profile_redirect", true),
				f: "routeProfileRedirect",
			},
			{
				url: AlcUrl.getUrlPattern("profile", true),
				f: "routeProfile",
			},
			{
				url: AlcUrl.getUrlPattern("hall_of_fame", true),
				f: "routeHallOfFame",
			},
			{
				url: AlcUrl.getUrlPattern("hall_of_fame_section", true),
				f: "routeHallOfFame",
			},
			{
				url: AlcUrl.getUrlPattern("help", true),
				f: "routeHelp",
			},
			{
				url: AlcUrl.getUrlPattern("help_section", true),
				f: "routeHelp",
			},
			{
				url: AlcUrl.getUrlPattern("settings", true),
				f: "routeSettings",
			},
			{
				url: AlcUrl.getUrlPattern("user_problem", true),
				f: "routeUserProblem",
			},
			{
				url: AlcUrl.getUrlPattern("set_focus", true),
				f: "routeSetFocus",
			},
			{
				url: AlcUrl.getUrlPattern("welcome", true),
				f: "routeWelcome",
			},
			{
				url: AlcUrl.getUrlPattern("reset", true),
				f: "routeReset",
			},
			{
				url: AlcUrl.getUrlPattern("admin", true),
				f: "routeAdmin",
			},
			{
				url: AlcUrl.getUrlPattern("admin_problem_none", true),
				f: "routeAdminProblem",
			},
			{
				url: AlcUrl.getUrlPattern("admin_problem", true),
				f: "routeAdminProblem",
			},
			{
				url: AlcUrl.getUrlPattern("admin_parser", true),
				f: "routeAdminParser",
			},
			{
				url: AlcUrl.getUrlPattern("error", true),
				f: "routeError",
			},
		],

		initialize: function (options) {
			// Create master model using AoPS.bootstrap_data (aliased as depenency
			// at top of file). This is optional; we just load from the server if
			// no data was provided.
			var master_model = new AlcMasterModel({
				user_id: bootstrap_data.alc_user_id,
				is_admin: bootstrap_data.alc_is_admin,
			});
			this.master_model = master_model;
			if (bootstrap_data.alc_init_data) {
				master_model.unpack(bootstrap_data.alc_init_data);
			}

			if (bootstrap_data.alc_real_user_id) {
				this.impersonateNotice(
					bootstrap_data.alc_user_id,
					bootstrap_data.alc_real_user_id
				);
			}
			AoPS.fixSidebarClassObserver();

			// Note that this.page only contains the main column. Anything in the side
			// columns is appended separately.
			this.page = new Page.constructPage("alc-page");

			// Main view for side column, which is separate from the page object.
			this.sidebar = new AlcVMisc.SidebarContainer({model: master_model});

			// Whatever constructed the router should append both this.page.$el and
			// this.sidebar.$el to appropriate positions.

			// Set up routes; see the route_data comment above for why this is needed.
			_.each(
				this.route_data,
				function (route_node) {
					var url = route_node.url;
					this.route(url, route_node.f);
					// Alias routes with a trailing slash if the pattern has no splat.
					if (url.indexOf("*") < 0 && url.slice(-1) !== "/") {
						this.route(url + "/", route_node.f);
					}
				},
				this
			);

			// Feed route
			if (Feed) {
				this.route(/^feed\/[0-9]+\/alcumus(.*)/, Feed.onFeedRoute);
			}

			// Event for manually hopping to a URL, as though a data-alc-stay link were
			// clicked.
			this.listenTo(Backbone, "alc_goto_url", function (url) {
				// URL is expected to be an AlcUrl.getUrl return, which includes the root.
				this.navigateRoot(url, {trigger: true});
			});

			setupAlcPageMinHeightHack();
		},

		impersonateNotice: function (imp_user_id, real_user_id) {
			var text = "You are impersonating user ID " + imp_user_id + ".";
			var imp_div = $("<div></div>")
				.addClass("alc-impersonate-warning")
				.text(text);
			$("body").append(imp_div);
		},

		// Helper function to use when given a URL including the root part. Such
		// URLs need the root stripped off
		navigateRoot: function () {
			var args = _.toArray(arguments);
			args[0] = args[0].replace(AlcUrl.getRoot(), "");
			return this.navigate.apply(this, args);
		},

		startHistory: function (use_push_state) {
			// Don't display anything until the current user has loaded.
			this.master_model.requestLoad(function (ok, data) {
				if (!ok) {
					data.zero_load = true;
					return this.routeError(data);
				}

				// Parameters to pass to Backbone.history.start
				var start_params;

				if (use_push_state) {
					start_params = {
						pushState: true,
						root: AlcUrl.getRoot(),
					};
				} else {
					start_params = {};
					// When not using push state, all URLs computed using AlcUrl need
					// to have a root of #.
					AlcUrl.setRoot("#");
				}

				// Needed for feed
				AoPS.router_root = AlcUrl.getRoot();
				AoPS.pushState_attr = "data-alc-stay";
				// Construct the Feed in a set timeout call; this prevents the page
				// from breaking completely if the call errors out.
				setTimeout(function () {
					Feed && Feed.constructFeed();
					Feed && Feed.setPageFeed(63); // Alcumus category
				}, 0);

				// A link with the custom data-alc-stay attribute is intended to stay on the
				// page and not reload. We hijack all such links here.
				$(document).on(
					"click",
					"a[href][data-alc-stay]",
					_.bind(function (evt) {
						evt.preventDefault();
						// Clicking a link in a modal should close that modal.
						Modal.closeAllModals();
						// An a href contains the URL root so that new-tab clicks work.
						this.navigateRoot($(evt.currentTarget).attr("href"), {
							trigger: true,
						});
					}, this)
				);

				// Server routing issues sometimes mean we get an m/ in the URL that
				// shouldn't be there. Strip it out manually if it's there.
				if (window.location.href.match("/m/alcumus")) {
					window.history.replaceState(
						{},
						document.title,
						location.href.replace("/m/alcumus", "/alcumus")
					);
				}

				// If the user's first URL is the error route, they probably refreshed
				// and are not expecting to see the error page again.
				if (window.location.href.match(/error$/)) {
					// Don't let Backbone.history.start parse the current URL.
					// But we do need to call start before using navigate.
					start_params.silent = true;
					Backbone.history.start(start_params);
					this.navigateRoot(AlcUrl.getUrl("index"), {
						trigger: true,
						replace: true,
					});
				} else {
					Backbone.history.start(start_params);
				}

				// No better place for this one; we want to poll the server for
				// user updates after the user has loaded.
				this.master_model.getUser("me").pollServerForUpdates(true);
			}, this);
		},

		// Call in each route to specify whether a vertical scrollbar should be
		// allowed on this page.
		enableVScroll: function (new_value) {
			this.use_v_scroll = !!new_value;

			// Need to make one bound function ever, so that we can use $.off correctly.
			this.adjustHeightBound =
				this.adjustHeightBound || _.bind(this.adjustHeight, this);

			this.adjustHeight();
			// Not sure why, but this fixes some things
			setTimeout(this.adjustHeightBound, 10);

			// Only need to watch resize event if we're disabling the vertical scrollbar.
			if (new_value) {
				$(window).off("resize", this.adjustHeightBound);
			} else {
				$(window).on("resize", this.adjustHeightBound);
			}

			// Also watch for the submenu expanding
			if (!this.watching_submenu_icon) {
				$("#submenu-icon").click(this.adjustHeightBound);
				this.watching_submenu_icon = true;
			}
		},

		// Helper for enableVScroll. Adjusts the height of the main part of the
		// page according to whether scrolling is enabled (this.use_v_scroll).
		adjustHeight: function () {
			// The main part of the page whose height we will set.
			var container = this.page.$el;

			if (this.use_v_scroll) {
				// Vertical scrollbar okay; remove all height restrictions.
				container.height("auto");
				return;
			}

			// Otherwise, we need to set height to avoid vertical scrolling.

			// Compute height of content. Start with the full window height...
			var height = $(window).height();
			// ... subtract everything above...
			height -= container.offset().top;
			// ... and everything below, which is just footer plus an arbitrary margin.
			height -= $("#small-footer-wrapper").outerHeight() + 20;

			container.height(height);
		},

		//
		// BEGIN ROUTES
		//

		routeIndex: function () {
			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus"},
				],
				"data-alc-stay"
			);
			document.title = "Alcumus - Art of Problem Solving";

			this.page.clearPage();

			var master = this.master_model;
			this.page.showElement({
				id: "alc-index",
				constructor: function () {
					return new AlcVMisc.Introduction({model: master});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("intro");
		},

		routeProblem: function () {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Play"},
				],
				"data-alc-stay"
			);
			document.title = "Play Alcumus - Art of Problem Solving";

			this.page.clearPage();

			var user_me = this.master_model.getUser("me");
			this.page.showElement({
				id: "alc-problem-main",
				constructor: function () {
					return new AlcVProblem.ProblemPage({model: user_me});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("problem");
		},

		routeReportRedirect: function () {
			this.navigateRoot(AlcUrl.getUrl("report", "me"), {
				trigger: true,
				replace: true,
			});
		},

		routeReport: function (user_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.showReport(user_id);
		},

		routeReportSubject: function (user_id, subject_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.showReport(user_id, subject_id);
		},

		routeReportSubjectTopic: function (user_id, subject_id, topic_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.showReport(user_id, subject_id, null, topic_id);
		},

		routeReportClass: function (user_id, class_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.showReport(user_id, null, class_id);
		},

		routeReportClassTopic: function (user_id, class_id, topic_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.showReport(user_id, null, class_id, topic_id);
		},

		routeReportTrial: function (user_id, trial_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			var user_model = this.master_model.getUser(user_id);
			var trial_model = user_model.get("trials").getOrCreate(trial_id);
			// Like above, 'me' and own ID should be considered same for caching.
			user_id = user_model.getUrlId();

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Report", url: AlcUrl.getUrl("report", user_id)},
					{text: "Review Problem"},
				],
				"data-alc-stay"
			);
			document.title = "Alcumus - Review Problem - Art of Problem Solving";

			this.page.clearPage();

			this.page.showElement({
				id: "alc-past-problem-" + trial_id,
				constructor: function () {
					return new AlcVProblem.PastPanel({model: trial_model});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("report");
		},

		routeProfileRedirect: function () {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.navigateRoot(AlcUrl.getUrl("profile", "me"), {
				trigger: true,
				replace: true,
			});
		},

		routeProfile: function (user_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			var user_model = this.master_model.getOrCreateUser(user_id);
			// 'me' and own ID should be considered same for caching.
			user_id = user_model.getUrlId();

			var last_text = user_id === "me" ? "My Profile" : "Profile";
			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: last_text},
				],
				"data-alc-stay"
			);
			document.title = last_text + " - Art of Problem Solving";

			this.page.clearPage();
			this.page.showLoader();
			$(window).scrollTop(0);

			user_model.requestLoad(function (ok, data) {
				this.page.clearPage();

				if (!ok) {
					// TODO (generic error)
					this.navigateRoot(AlcUrl.getUrl("index"), {
						trigger: true,
						replace: true,
					});
					return;
				}

				if (!user_model.get("is_me")) {
					this.page.setBreadcrumbs(
						[
							{
								text: "Resources",
								url: "/resources",
								no_stay: true,
							},
							{text: "Alcumus", url: AlcUrl.getUrl("index")},
							{
								text: "Profile",
								url: AlcUrl.getUrl("profile", "me"),
							},
							{
								text: user_model.get("username"),
							},
						],
						"data-alc-stay"
					);
					document.title =
						user_model.get("username") + " - Art of Problem Solving";
				}

				this.page.showElement({
					id: "alc-profile-" + user_id + "-main",
					constructor: function () {
						return new AlcVProfile.MainPanel({model: user_model});
					},
				});
				if (user_model.canSeeProfile()) {
					this.page.showElement({
						id: "alc-profile-" + user_id + "-bottom",
						constructor: function () {
							return new AlcVProfile.BottomPanel({
								model: user_model,
							});
						},
					});
				}
			}, this);

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("profile");
		},

		routeHallOfFame: function (section_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			var hof_model = this.master_model.get("hall_of_fame");

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Hall of Fame"},
				],
				"data-alc-stay"
			);
			document.title = "Hall of Fame - Art of Problem Solving";

			this.page.clearPage();

			var hof_el = this.page.showElement({
				id: "alc-hall-of-fame",
				constructor: function () {
					return new AlcVMisc.HallOfFame({model: hof_model});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("hall_of_fame", section_id);
			hof_el.view.whenRendered(function () {
				this.sidebar.setSubmenu("hall_of_fame", hof_el.view.getKeyList());
				// If we just created the submenu, we need to set the subpage again.
				this.sidebar.setCurrentPage("hall_of_fame", section_id);
				hof_el.view.scrollToSection(section_id);
			}, this);
		},

		routeHelp: function (section_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Help"},
				],
				"data-alc-stay"
			);
			document.title = "Help - Art of Problem Solving";

			this.page.clearPage();

			var help_el = this.page.showElement({
				id: "alc-help",
				constructor: function () {
					return new AlcVMisc.Help();
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("help", section_id);
			help_el.view.whenRendered(function () {
				this.sidebar.setSubmenu("help", help_el.view.getKeyList());
				// If we just created the submenu, we need to set the subpage again.
				this.sidebar.setCurrentPage("help", section_id);
				help_el.view.scrollToSection(section_id);
			}, this);
		},

		routeSettings: function () {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			var settings_model = this.master_model.getUser("me").get("settings");

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Settings"},
				],
				"data-alc-stay"
			);
			document.title = "Settings - Art of Problem Solving";

			this.page.clearPage();

			this.page.showElement({
				id: "alc-settings",
				constructor: function () {
					return new AlcVMisc.Settings({model: settings_model});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("settings");
		},

		routeReset: function () {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Settings", url: AlcUrl.getUrl("settings")},
					{text: "Reset"},
				],
				"data-alc-stay"
			);
			document.title = "Reset - Art of Problem Solving";

			this.page.clearPage();

			var user_model = this.master_model.getUser("me");
			this.page.showElement({
				id: "alc-reset-panel",
				constructor: function () {
					return new AlcVMisc.ResetPanel({model: user_model});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("settings");
		},

		routeUserProblem: function (problem_id) {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!this.master_model.get("initialized")) {
				return this.blockUninitialized();
			}

			this.page.clearPage();
			this.page.showLoader();

			var user_model = this.master_model.getUser("me");
			user_model.findTrialByProblemId(
				problem_id,
				function (ok, data) {
					this.page.clearPage();

					if (!ok) {
						// Not found or some other error; just zip back to index
						Modal.showAlert(
							"The link you clicked is for Alcumus problem " +
								problem_id +
								". " +
								"You have not done this problem, so Alcumus cannot find any data to show to you. " +
								"<br><br>" +
								"You have been redirected back to the index."
						);
						this.navigateRoot(AlcUrl.getUrl("index"), {
							trigger: true,
							replace: true,
						});
					} else {
						// Success. data is a trial model; show its report page
						this.navigateRoot(AlcUrl.getUrl("report_trial", "me", data.id), {
							trigger: true,
							replace: true,
						});
					}
				},
				this
			);
		},

		routeSetFocus: function (parent_id, parent_type, topic_id) {
			if (!AoPS.session.logged_in || !AoPS.session.initialized) {
				this.navigateRoot(AlcUrl.getUrl("index"), {
					trigger: true,
					replace: true,
				});
				return;
			}

			this.page.clearPage();
			this.page.showLoader();

			var user_model = this.master_model.getUser("me");
			var new_focus = {
				parent_type: parent_type,
				parent_id: parent_id,
				topic_id: topic_id,
			};
			user_model.changeFocus(
				new_focus,
				function (ok, data) {
					this.page.clearPage();

					if (!ok) {
						this.navigateRoot(AlcUrl.getUrl("problem"), {
							trigger: true,
							replace: true,
						});
						Modal.showAlert(
							"An error occurred when the link you just clicked " +
								"tried to set your focus. You have been redirected to the problem " +
								"page with your original focus intact and may either continue " +
								"solving problems in that topic or change your focus now."
						);
					} else {
						this.navigateRoot(AlcUrl.getUrl("problem"), {
							trigger: true,
							replace: true,
						});
					}
				},
				{context: this}
			);
		},

		routeWelcome: function () {
			if (!AoPS.session.logged_in) {
				return this.blockUnregistered();
			}

			if (!AoPS.session.initialized) {
				return this.blockUninitialized();
			}

			this.page.clearPage();
			this.page.showLoader();

			var user_model = this.master_model.getUser("me");
			user_model.set({is_tutorial_active: 1});
			this.navigateRoot(AlcUrl.getUrl("problem"), {
				trigger: true,
				replace: true,
			});
		},

		routeAdmin: function () {
			var AlcVAdmin = AoPS.Alcumus.Views.Admin;
			if (!AlcVAdmin) {
				this.navigateRoot(AlcUrl.getUrl("index"), {
					trigger: true,
					replace: true,
				});
				return;
			}

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Admin"},
				],
				"data-alc-stay"
			);
			document.title = "Admin - Art of Problem Solving";

			this.page.clearPage();

			var master_model = this.master_model;
			this.page.showElement({
				id: "alc-admin-panel",
				constructor: function () {
					return new AlcVAdmin.MainPanel({model: master_model});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("admin");
		},

		routeAdminProblem: function (problem_id) {
			var AlcVAdmin = AoPS.Alcumus.Views.Admin;
			if (!AlcVAdmin) {
				this.navigateRoot(AlcUrl.getUrl("index"), {
					trigger: true,
					replace: true,
				});
				return;
			}

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Admin", url: AlcUrl.getUrl("admin")},
					{text: "Problem"},
				],
				"data-alc-stay"
			);
			document.title = "Admin - Art of Problem Solving";

			this.page.clearPage();

			var master_model = this.master_model;
			var problem_el = this.page.showElement({
				id: "alc-admin-problem-panel",
				constructor: function () {
					return new AlcVAdmin.ProblemPanel({model: master_model});
				},
			});
			problem_el.view.loadProblem(problem_id);

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("admin");
		},

		routeAdminParser: function () {
			var AlcVAdmin = AoPS.Alcumus.Views.Admin;
			if (!AlcVAdmin) {
				this.navigateRoot(AlcUrl.getUrl("index"), {
					trigger: true,
					replace: true,
				});
				return;
			}

			this.page.setBreadcrumbs(
				[
					{text: "Resources", url: "/resources", no_stay: true},
					{text: "Alcumus", url: AlcUrl.getUrl("index")},
					{text: "Admin", url: AlcUrl.getUrl("admin")},
					{text: "Parser"},
				],
				"data-alc-stay"
			);
			document.title = "Admin - Art of Problem Solving";

			this.page.clearPage();

			var master_model = this.master_model;
			this.page.showElement({
				id: "alc-admin-parser-panel",
				constructor: function () {
					return new AlcVAdmin.ParserPanel({model: master_model});
				},
			});

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("admin");
		},

		routeError: function (data) {
			data = data || {};

			// May have gotten here through an event or direct method call, so make
			// sure the URL is up-to-date.
			this.navigateRoot(AlcUrl.getUrl("error"), {
				trigger: true,
				replace: true,
			});

			this.page.clearPage();
			// Intentionally keep the breadcrumbs intact, so users can
			// get back to safer ground easier.

			var html =
				'<div class="error-box">' +
				"<p>An error occurred while you were browsing Alcumus. " +
				(data.error_msg || "") +
				"</p>" +
				"<p>" +
				AlcVBase.getErrorFooter(data) +
				"</p>" +
				'<p>Click <a href="' +
				AlcUrl.getUrl("index") +
				'" data-alc-stay>here</a> ' +
				"if you want to return to the index.</p>" +
				"</div>";
			this.page.throwError({
				error_type: "custom",
				error_msg: html,
			});
			document.title = "Error - Art of Problem Solving";
			console.log("Raw error data:", data);

			this.enableVScroll(true);
			this.sidebar.setCurrentPage("error");
		},

		route404: function () {
			console.log("Bad URL:", window.location.href);
			this.routeError({
				error_code: "404",
				error_msg: "The URL you went to does not exist.",
			});
		},

		//
		// END ROUTES
		//

		// Route helper functions

		// Used in most routes to prevent the unregistered users from proceeding
		// to an inevitably broken page.
		blockUnregistered: function () {
			this.page.clearPage();
			AlcVBase.showSpecialError(
				{
					error_code: "E_UNREGISTERED",
				},
				{
					onClose: _.bind(function () {
						this.navigateRoot(AlcUrl.getUrl("index"), {
							trigger: true,
							replace: true,
						});
					}, this),
				}
			);
		},

		blockUninitialized: function () {
			this.page.clearPage();
			AoPS.Initialize.display({escapable: false});
		},

		// Helper function for various report page routes.
		// user_id should always be set.
		// One of subject_id and class_id should be set if not on the main page.
		// topic_id should be set only if on the topic page.
		showReport: function (user_id, subject_id, class_id, topic_id) {
			// Various permission requirements are in report pages.
			var master = this.master_model;
			var can_view =
				master.isMyId(user_id) || master.get("is_admin") || master.isTeacher();
			if (!can_view) {
				this.routeError({
					error_code: "E_NO_AUTH",
					error_msg: "You do not have permission to view this user's report.",
				});
				return;
			}

			// See the AlcVReport module for the format of models to send to report views.
			// These variables hold these models, and are altered according to the
			// logic below where subject_id etc. are processed.
			var main_model = master.getOrCreateUser(user_id);
			var user_model = main_model;
			var cat_model = null;
			var topic_model = null;

			// Convert user's own ID to 'me' so that we don't create separate page
			// element IDs for both 'me' and their ID number.
			user_id = user_model.getUrlId();

			// Here is where we change the above variables according to the ID values.

			// Determining cat_model
			if (subject_id) {
				main_model = user_model.get("subjects").getOrCreate(subject_id);
				cat_model = main_model;
			} else if (class_id) {
				main_model = user_model.get("classes").getOrCreate(class_id);
				cat_model = main_model;
			}

			// Determining topic_model
			if (topic_id) {
				main_model = user_model.get("topics").getOrCreate(topic_id);
				topic_model = main_model;
			}

			// Models to pass in to each view
			var models = {
				model: main_model,
				user_model: user_model,
				cat_model: cat_model,
				topic_model: topic_model,
			};

			// Okay, now we're ready to start displaying things.
			this.setReportBreadcrumbs(models);

			var page_el = this.page.findActiveElement("alc-report-page");
			if (!page_el) {
				this.page.clearPage();

				// This reuses the same page element for all report views, since there's
				// some weird scroll position preserving behavior that's needed.
				page_el = this.page.showElement({
					id: "alc-report-page",
					constructor: function () {
						return new AlcVReport.ReportPage({models: models});
					},
				});
			}
			page_el.view.whenRendered(function () {
				page_el.view.setModels(models);
			});

			this.enableVScroll(false);
			this.sidebar.setCurrentPage("report");
		},

		// Helper for showReport. Takes the models table passed to views and returns
		// the list of breadcrumbs to set.
		// The second parameter is internal; this function recursively calls itself
		// a second time after some loading, and the second parameter is used to
		// stop the recursion depth at 2.
		setReportBreadcrumbs: function (models, no_load_request) {
			var user_model = models.user_model;
			var user_id = user_model.getUrlId();
			var cat_model = models.cat_model;
			var topic_model = models.topic_model;
			var breadcrumbs = [
				{text: "Resources", url: "/resources", no_stay: true},
				{text: "Alcumus", url: AlcUrl.getUrl("index")},
				{text: "Report", url: AlcUrl.getUrl("report", user_id)},
			];

			if (cat_model) {
				breadcrumbs.push({
					text: cat_model.get("name"),
					url: AlcUrl.getUrl(
						"report_" + cat_model.model_type,
						user_id,
						cat_model.id
					),
				});
			}

			if (topic_model) {
				// This is the last crumb, if present, and never has a URL.
				breadcrumbs.push({
					text: topic_model.get("name"),
				});
			}

			// The last part of breadcrumbs does not need a URL
			var last = breadcrumbs[breadcrumbs.length - 1];
			delete last.url;
			this.page.setBreadcrumbs(breadcrumbs, "data-alc-stay");
			document.title = last.text + " - Art of Problem Solving";

			// The names we grabbed above are not filled in if loading hasn't
			// finished. If so, rerun this function again after the load is done.
			if (!no_load_request && !user_model.isLoaded()) {
				user_model.requestLoad(function (ok, data) {
					// Second parameter is true to prevent running this branch again.
					if (ok) {
						this.setReportBreadcrumbs(models, true);
					}
				}, this);
			}
		},
	});

	$(window).on("load", function () {
		var router = new Alcumus.Router();
		$("#main-column").append(router.page.$el);
		$("#side-column").append(router.sidebar.$el);

		router.startHistory(USE_PUSH_STATE);
	});

	return Alcumus;
})(AoPS.Alcumus);
